import { useAppSelector } from '../../../Hooks/useAppSelector'
import { LabContactsSelectors } from '../StoreAdapter'

export const useLabContactsSelector = () => {
  return useAppSelector(LabContactsSelectors.selectEntities)
}
